import { API_PATH } from "@/common/constant";
import ApiService from "@/common/api.service";

export const TARGET_SETTING_CREATE = (params) =>
  ApiService.query(API_PATH.TARGET_SETTING_CREATE, { ...params });
export const TARGET_SETTING_SAVE = (request) =>
  ApiService.post(API_PATH.TARGET_SETTING_SAVE, request);
export const TARGET_SETTING_DELETE_CP_TABLE = (params) =>
  ApiService.delete(API_PATH.TARGET_SETTING_DELETE_CP_TABLE, { ...params });
export const TARGET_SETTING_FILTER = (filterRequest) =>
  ApiService.post(API_PATH.TARGET_SETTING_FILTER, filterRequest);
export const REGISTER_MISSION = (params) =>
  ApiService.post(API_PATH.REGISTER_MISSION, { ...params });
export const REGISTER_GOAL = (params) =>
  ApiService.post(API_PATH.REGISTER_GOAL, { ...params });

const GET_HEADS = async (API_PATH) => {
  try {
    let { data } = await ApiService.get(API_PATH);
    return mappingHeads(data);
  } catch (e) {
    console.error(e);
    return [];
  }
};

function mappingHeads(departments) {
  departments.forEach((h) => {
    h.text = h.departmentName;
    h.value = h.id;
  });
  return departments;
}
export const TARGET_SETTING_GET_HEADS = () => {
  return GET_HEADS(API_PATH.TARGET_SETTING_GET_HEADS);
};

export const GET_ALL_HEADS = () => {
  return GET_HEADS(API_PATH.GET_ALL_HEADS);
};
export const TARGET_SETTING_SUBMIT = (request) =>
  ApiService.post(API_PATH.TARGET_SETTING_SUBMIT, request);
export const TARGET_SETTING_REJECT = (params) =>
  ApiService.query(API_PATH.TARGET_SETTING_REJECT, { ...params });
export const TARGET_SETTING_APPROVE = (request) =>
  ApiService.post(API_PATH.TARGET_SETTING_APPROVE, request);
export const TARGET_SETTING_GET_YEAR_SESSION = (params) =>
  ApiService.query(API_PATH.TARGET_SETTING_GET_YEAR_SESSION, { ...params });
export const TARGET_SETTING_ROLLBACK = (params) =>
  ApiService.query(API_PATH.TARGET_SETTING_ROLLBACK, { ...params });

export const GET_MAX_TARGET_VALUE_API = () =>
  ApiService.query(API_PATH.TARGET_SETTING_GET_MAX_TARGET_SCORE);
export const UPDATE_MAX_TARGET_SCORE_API = (params) =>
  ApiService.put(API_PATH.TARGET_SETTING_UPDATE_MAX_TARGET_SCORE, {
    ...params,
  });
export const CHECK_TARGET_AVAILABLE = (params) =>
  ApiService.query(API_PATH.CHECK_TARGET_AVAILABLE, { ...params });

export const REMOVE_MEMBER_TARGET = (request) =>
  ApiService.post(API_PATH.REMOVE_MEMBER_TARGET, request);
